import { createItemCacheLockId } from 'owa-items-cache';
import { getTodoCacheLock } from './getTodoCacheLock';

export function createTodoCacheLock() {
    const lockId = createItemCacheLockId();
    return getTodoCacheLock(lockId);
}
